export default __webpack_public_path__ + "static/admin-edit-a38e3f7d.svg";